<template>
  <j-modal
    :title="title"
    :width="1200"
    :visible="visible"
    :footer="null"
    :destroyOnClose="true"
    :centered="true"
    @cancel="handleCancel"
    :bodyStyle="{
      overflowY: 'hidden',
      padding: '0px',
      height: 'calc(100vh - 67px) !important',
      maxHeight: '880px',
    }"
  >
    <a-spin :spinning="loading" class="a-spin-modeler">
      <iframe
        width="100%"
        height="100%"
        :src="src"
        style="border: none; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px"
      ></iframe>
    </a-spin>
  </j-modal>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import Vue from 'vue'
import store from '@/store'
import { ACCESS_TOKEN } from '@/store/mutation-types'

export default {
  name: 'ModelerModal',
  created() {},
  data() {
    return {
      visible: false,
      loading: false,
      modelId: '',
      type: '',
      url: {
        createModel: 'flow/model/create',
        delete: '/flow/model/delete',
      },
    }
  },
  computed: {
    src() {
      return '/modeler.html?type=' + this.type + '&modelId=' + this.modelId + '&_t=' + Date.now()
    },
    title() {
      if (this.type == 'add') {
        return this.$t('disp.btn.add')
      } else {
        return this.$t('disp.btn.edit')
      }
    },
  },
  methods: {
    handleCancel() {
      var that = this
      this.$confirm({
        title: that.$t('disp.flow.confirm.cancelEdit'),
        content: (h) => <div style="color:red;">{that.$t('disp.flow.withoutSave')}</div>,
        onOk() {
          that.visible = false

          // 新規モード前作成のモデルを削除
          if (that.type == 'add') {
            postAction(that.url.delete, { modelId: that.modelId })
              .then((res) => {})
              .catch((err) => {})
          }
        },
        onCancel() {
          console.log('Cancel')
        },
      })
    },
    editModel(id) {
      this.type = 'edit'
      this.modelId = id
      this.visible = true
    },
    createModel() {
      getAction(this.url.createModel, {}).then((res) => {
        if (res.success) {
          this.type = 'add'
          this.modelId = res.message
          this.visible = true
        }
      })
    },
    modelerSaved(willClose) {
      var that = this
      if (that.type == 'add') {
        that.$message.success(that.$t('msg.insert.success'))
        that.type = 'edit'
      } else {
        that.$message.success(that.$t('msg.update.success'))
      }

      that.loading = false

      if (willClose) {
        that.visible = false
      }

      that.$emit('modelerSaved')
    },
    handleWarning(message) {
      this.$message.warn(this.$t(message))
    },
    handleException(message) {
      this.loading = false

      if (message == 'msg.invalidToken') {
        if (window.hasError500 == undefined || window.hasError500 == false) {
          window.hasError500 = true
          antd.Modal.error({
            title: this.$t('disp.error'),
            content: this.$t('msg.sessionTimeout'),
            okText: this.$t('disp.btn.confirm'),
            mask: true,
            onOk: () => {
              store.dispatch('Logout').then(() => {
                Vue.ls.remove(ACCESS_TOKEN)
                // window.location.reload()
                this.$router.push({ path: '/user' })
                window.hasError500 = false
              })
            },
          })
        }
      } else {
        this.$notification.error({
          message: this.$t('disp.error'),
          description: this.$t(message.split('\n')[1].substring(message.split('\n')[1].indexOf('msg.'))),
        })
      }
    },
  },
}
</script>

<style lang="less">
.a-spin-modeler {
  height: 100%;

  .ant-spin-container {
    height: 100%;
  }
}
</style>
